import React, { createContext, useContext, useState, useEffect } from "react";

const SidebarContext = createContext();

export const SidebarProvider = ({ children }) => {
  const [expandedSidebar, setExpandedSidebar] = useState([]);
  const [expandState, setExpandState] = useState({});
  const [isCollapsed, setIsCollapsed] = useState(false);


  useEffect(() => {
    setExpandedSidebar([]);
    setExpandState({});
    setIsCollapsed(false);
  }, []);

  const resetSidebarState = () => {
    setExpandedSidebar([]);
    setExpandState({});
    setIsCollapsed(false);
  };

    const handleNavDropDown = (key) => {
    const currentExpandedSidebar = expandedSidebar;
    if(expandedSidebar[expandedSidebar.length-1] !== key){
      currentExpandedSidebar.pop()
    }
    const isSidebarExpanded = currentExpandedSidebar.includes(key);

    let obj = {};
    isSidebarExpanded ? (obj[key] = false) :  (obj[key] = true);
    setExpandState(obj)
    
    const newExpandedSidebar = isSidebarExpanded
      ? currentExpandedSidebar.filter((id) => id !== key)
      : currentExpandedSidebar.concat(key);
      setExpandedSidebar(newExpandedSidebar);
}



  return (
    <SidebarContext.Provider
      value={{ 
        expandState, 
        expandedSidebar, 
        setExpandState, 
        setExpandedSidebar,  
        isCollapsed, 
        setIsCollapsed, 
        handleNavDropDown, 
        resetSidebarState 
      }}>
      {children}
    </SidebarContext.Provider>
  );
};

export const useSidebar = () => useContext(SidebarContext);
